import { Button, Flex, Modal, UploadFile } from "antd";
import { ISubscriptionPlan } from "../../types/interfaces";
import UploadButton from "../general/uploadButton/uploadButton";
import { INTERVALS_TEXT } from "../../constants/constants";

interface Props {
  handleCancel: () => void;
  handleFileChange: (file: UploadFile | null, name: string) => void;
  handleOk: () => void;
  isModalOpen: boolean;
  loading?: boolean;
  selectedSubscription: ISubscriptionPlan | null;
  uploads: {
    [key: string]: {
      file: any;
    };
  };
}

function UploadReceiptModal({
  handleCancel,
  handleFileChange,
  handleOk,
  isModalOpen,
  loading,
  selectedSubscription,
  uploads,
}: Props) {
  return (
    <Modal
      title="Proceso de pago"
      open={isModalOpen}
      onOk={handleOk}
      width={600}
      closable={false}
      footer={[
        <Button
          key="submit"
          id={"submit"}
          type="primary"
          onClick={handleOk}
          loading={loading}
        >
          Guardar
        </Button>,
        <Button key="back" onClick={handleCancel}>
          Cancelar
        </Button>,
      ]}
      closeIcon={false}
      destroyOnClose
    >
      <div>
        {selectedSubscription && (
          <div>
            <Flex gap={10} align={"end"} style={{ marginBottom: "12px" }}>
              <h1 style={{ lineHeight: "24px", fontSize: "24px" }}>
                {selectedSubscription?.name}
              </h1>

              <p
                style={{
                  color: "#b1b1b1",
                  fontSize: "24px",
                  lineHeight: "24px",
                }}
              >
                {selectedSubscription?.price} USD /{" "}
                {INTERVALS_TEXT[selectedSubscription?.frequency]}
              </p>
            </Flex>

            <div className={"payment_instructions"}>
              <p>
                📌 <strong>¿Cómo activar tu suscripción?</strong>
              </p>

              <p>
                1️⃣ <strong>Realiza el pago</strong> mediante transferencia
                bancaria a una de nuestras cuentas:
              </p>
              <ul>
                <li>
                  <strong>Banco Pichincha</strong> - Cuenta: 1234567890
                </li>
                <li>
                  <strong>Banco del Ecuador</strong> - Cuenta: 0987654321
                </li>
              </ul>

              <p>
                2️⃣ <strong>Guarda el comprobante</strong> de la transacción.
                Asegúrate de que los datos sean visibles.
              </p>

              <p>
                3️⃣ <strong>Sube tu recibo de pago</strong> en el siguiente paso.
              </p>

              <p>
                4️⃣ <strong>Espera la aprobación</strong> de nuestro equipo. Tu
                suscripción quedará en estado <em>pendiente</em> hasta que
                verifiquemos tu pago. Te notificaremos cuando esté activa.
              </p>

              <p>¡Gracias por tu confianza! 💙</p>
            </div>
          </div>
        )}
      </div>
      <UploadButton
        name={"receipt"}
        file={uploads["receipt"]?.file}
        onFileChange={handleFileChange}
        usePreview={false}
        // url={photo}
        // instructions={"Dimensiones recomendadas: 1080x1080 px. Tamaño máximo: 5 MB"}
      />
    </Modal>
  );
}

export default UploadReceiptModal;
